exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h1 {\n    font-family: 'Cookie', cursive;\n    text-align: center;\n    margin: 0% 20%;\n    padding-top: 5vh;\n    position: relative;\n    font-size: 8vw;\n\n}\nh4 {\n    text-align: center;\n    font-size:  4vw;\n}\np {\n    text-align: center;\n    font-size: 2vw;\n}\nbutton {\n    color: rgba(255,255,255,.87);\n    background-color: #232b2b;\n    margin-left: auto;\n    margin-right: auto;\n    font-size: 2.5vw;\n    float: center;\n    position: relative;\n    display: block;\n    height: 5vh;\n    width: 15vw;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/app/thank-you/thank-you.component.css
// module id = ../../../../../src/app/thank-you/thank-you.component.css
// module chunks = main